import { render, staticRenderFns } from "./videoYsy.vue?vue&type=template&id=d426524c&scoped=true"
import script from "./videoYsy.vue?vue&type=script&lang=js"
export * from "./videoYsy.vue?vue&type=script&lang=js"
import style0 from "./videoYsy.vue?vue&type=style&index=0&id=d426524c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d426524c",
  null
  
)

export default component.exports